/* eslint-disable react/display-name */
import React from "react";

import AdGroupSelectionSlide from "../../views/CampaignCreationBasicSlides/AdGroupSelectionSlide";
import AdvertiserSelectionSlide from "../../views/CampaignCreationBasicSlides/AdvertiserSelectionSlide";
import CampaignBasicDetailsSlide from "../../views/CampaignCreationBasicSlides/CampaignBasicDetailsSlide";
import CampaignSummarySlide from "../../views/CampaignCreationBasicSlides/CampaignSummarySlide";
import LandingPageSelectionSlide from "../../views/CampaignCreationBasicSlides/LandingPageSelectionSlide";
import { BaseStep, BaseStepComponentProps } from "../../components/modules/BaseStepper/BaseStepper";

export const steps: BaseStep[] = [
  {
    order: 1,
    label: "Select Advertiser",
    stepComponent: (props: BaseStepComponentProps) => <AdvertiserSelectionSlide {...props} />,
  },
  {
    order: 2,
    label: "Campaign Details",
    stepComponent: (props: BaseStepComponentProps) => <CampaignBasicDetailsSlide {...props} />,
  },
  {
    order: 8,
    label: "Landing Page",
    stepComponent: (props: BaseStepComponentProps) => <LandingPageSelectionSlide {...props} />,
  },
  {
    order: 9,
    label: "Ad Group",
    stepComponent: (props: BaseStepComponentProps) => <AdGroupSelectionSlide {...props} />,
  },
  {
    order: 10,
    label: "Summary",
    stepComponent: (props: BaseStepComponentProps) => <CampaignSummarySlide {...props} />,
  },
];
